/**
 * Title Generation Policy
 *
 * Encodes when the chat UI should auto-generate a first-response title.
 *
 * Primary responsibilities:
 * - Keep group chats out of direct-message title generation flows
 * - Allow direct chats to keep the existing first-response rename behavior
 *
 * Dependencies:
 * - Supabase generated chat row types
 */

import { Tables } from '@/supabase/types'

export function shouldScheduleFirstResponseTitleGeneration(
  chat: Pick<Tables<'chats'>, 'id' | 'is_group_chat'> | null | undefined
) {
  return Boolean(chat?.id && !chat.is_group_chat)
}
